import type { AlgoliaClient } from "@lib/wrappers/algolia";
import { algoliaSearch, algoliaBrowse } from "@lib/wrappers/algolia";
import { useMemo } from "react";

export const useAlgoliaClient = (
    locale: string
): {
    searchClient: AlgoliaClient;
    browseClient: AlgoliaClient;
    indexName: string;
} => {
    const { algoliaBrowse: browseClient, algoliaSearch: searchClient } = useMemo(
        () => ({
            algoliaBrowse: algoliaBrowse(locale),
            algoliaSearch: algoliaSearch(locale),
        }),
        [locale]
    );
    return { searchClient, browseClient, indexName: browseClient.index.indexName };
};
